import { useEffect } from 'react';

interface JsonLdProps {
  data: Record<string, unknown>;
  /** Unique id so multiple schemas can coexist on one page */
  id: string;
}

/**
 * Injects a JSON-LD <script> into <head> and removes it on unmount.
 * Renders nothing visible — purely a head side-effect.
 */
export const JsonLd: React.FC<JsonLdProps> = ({ data, id }) => {
  useEffect(() => {
    let script = document.getElementById(id) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement('script');
      script.id = id;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.text = JSON.stringify(data);

    return () => {
      document.getElementById(id)?.remove();
    };
  }, [data, id]);

  return null;
};
